import { shallowEqual, useSelector } from 'react-redux'
import { ApplicationState } from 'Store/intialState'

const useShallowEqualSelector = <TSelected = unknown>(
  selector: (state: ApplicationState) => TSelected
) => useSelector(selector, shallowEqual)

export default useShallowEqualSelector
